<template>

 <div>
    <div v-if="type=='A'">
        <button @click="type='B'" type="button" class="btn btn-link" >
            <strong>NOTA DI CREDITO</strong>                
        </button>

    </div>    
    <div v-else >
        
        <button @click="setTotal(-1)" type="button" class="btn btn-link" >
            <strong :style="{color:'brown'}">ANNULLA NOTA DI CREDITO</strong>                 
        </button>
        <div class="input-group">
        <div class="input-group-prepend">
          
          <div class="input-group-text"><strong>TOTALE RESO</strong></div>
            <span class="input-group-text">€</span>
        </div>
        <input  @input="setTotal(total)" ref="inputRefund" v-focus type="number" step="0.01"  :style="{fontSize: '30px'}" class="form-control-sm" id="refund" :placeholder="'RESO'" v-model="total">      
        </div>

    </div>

</div>
  

    </template>
    <script>
    
    
          
    export default {
     
      props : [], 
      
     data () {
        return {
        
        type      : 'A',    
        total     : 0.00,
    
        }
      },
      directives: 
        {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()
          el.select()
          }
       
      }
    },
    
    mounted()
    {
        
         this.total = this.total.toFixed(2)
    },  
    
    methods : {
     
    setTotal(total)
    {
      if(total == -1)
      {
        this.total = 0.00
        this.type = 'A'
        total = 0
      }
      this.$emit('update',total)  
        
    },

        
}
}
    </script>
    <style scoped>
    input{
        font-size_ : 24px;
    }
    
    </style>
    